// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Interesting_wrapper__1r6G1","title":"Interesting_title__2rmnT","wrap":"Interesting_wrap__14ZEY","card":"Interesting_card__1oTks","btns":"Interesting_btns__3-_gD"};